import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>ウェブアクセシビリティチェックリスト</>,
  alt: 'ウェブアクセシビリティチェックリスト',
  readText: <>2024年4月より対応が義務化されたウェブアクセシビリティをわかりやすく解説</>,
  imgLarge: '/images/img/download/webaccessibilitychecklist/thumbnail_web.webp',
  imgCapture: '/images/img/download/webaccessibilitychecklist/capture_web.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料では国家規格「JIS X 8341-3:2016」に基づいたウェブアクセシビリティを私たちの解釈の下、文章をより簡略化して解説しております。現在提供しているウェブサービスが、ウェブアクセシビリティをどこまで実現できているかを知りたい方や、チェックリストを用いて診断したい方におすすめの資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '現在の国家規格に基づいた、ウェブアクセシビリティのポイント',
  secondHalf2: '自社がどこまでウェブアクセシビリティの対応ができているか',
  secondHalf3: '',
}

const DownloadWebAccessibilityChecklist: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'd84fa91c-40ae-4d78-a92b-f147d3439077', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], { opacity: 0, y: 50 });

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    });

    const commonTo = { opacity: 1, y: 0 };

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1);
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents
            leftContentData={leftContentData}
            isSecondContent={true}
          />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadWebAccessibilityChecklist
